<template>
    <div class="ah-page payment-page flex" @click="onPageClick">
        <div class="page-header" id="payment-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>請款單</h1>
                        <el-select v-model="yearSelect" class="title-dropdown">
                            <el-option v-for="item in yearList" :key="item.key" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </div>
                    <div class="actions">
                        <el-input
                            v-model="queryParams.PayooOrNote"
                            class="search"
                            placeholder="單號、摘要、付款對象"
                            prefix-icon="el-icon-search"
                            :clearable="true"
                            style="margin-right: 10px"
                            @keyup.enter.native="onSimpleSearchKeyUp"
                            @clear="updateData(true)"
                        ></el-input>
                        <el-button type="dark-transparent" round @click="isShowFilter = isShowFilter ? false : true" icon="el-icon-zoom-in"></el-button>
                        <el-button type="normal" :loading="isLoadingExport" @click="onExport(isPayed('G01'))">
                            {{ selectedDatas.length > 0 ? `匯出Excel（${selectedDatas.length}筆）` : '匯出Excel' }}
                        </el-button>
                        <el-button type="highlight" v-if="isAuth('A01')" @click="handleAddBtnClick">新增請款單</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <transition enter-active-class="animate__animated animate__fadeIn">
                    <div class="ah-card adv-search-card" v-if="isShowFilter">
                        <div class="title">進階搜尋</div>
                        <div class="content">
                            <el-form ref="form" :model="queryParams" label-width="220px" label-position="right" size="small">
                                <el-form-item label="關鍵字">
                                    <el-input v-model="queryParams.PayooOrNote" style="max-width: 400px" placeholder="單號、摘要、付款對象"></el-input>
                                </el-form-item>
                                <el-form-item label="請款類型">
                                    <el-select v-model="queryParams.PaymentType" style="margin" multiple @change="handleAdvSearchProjectTypeChange">
                                        <el-option v-for="item in paymentTypeFDatas" :key="item.value" :value="item.value" :label="item.name"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="請款單日期">
                                    <el-date-picker
                                        v-model="queryParams.PaymentDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="專案" v-if="queryParams.PaymentType.includes(2)">
                                    <el-select
                                        v-model="queryParams.ProjectId"
                                        :placeholder="companyInfo.displayProject ? '請選擇專案' : '請輸入專案名稱關鍵字（至少兩個字）'"
                                        :no-data-text="companyInfo.displayProject ? '無專案' : '無匹配專案'"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        remote
                                        :remote-method="projectRemoteMethod"
                                        style="min-width: 350px"
                                        @keydown.native.capture.enter="preventIMESelect"
                                    >
                                        <el-option v-for="item in projectList" :key="item.sno" :value="item.sno" :label="item.nam"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="特定費用項目" v-if="queryParams.PaymentType.includes(3)">
                                    <el-select v-model="queryParams.SpecialProjectId" style="min-width: 350px">
                                        <el-option v-for="item in spProjectList" :key="item.sno" :value="item.sno" :label="item.nam"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="收支項目">
                                    <ahSelectVariableStateItem ref="ahSelectVariableStateItem" v-model="queryParams.ITEM_SNO" :enableType="['payout', 'cOut', 'cOutElse']" :showTip="false" show-system-default multiple />
                                </el-form-item>
                                <el-form-item label="申請人">
                                    <el-select v-model="queryParams.Creator" filterable reserve-keyword multiple>
                                        <el-option v-for="item in creatorOptions" :key="item.sno" :value="item.sno" :label="item.onf ? item.nam : `${item.nam}（已停用）`" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="付款對象戶名">
                                    <el-input v-model="queryParams.PayeeName" style="max-width: 400px" placeholder="輸入關鍵字"></el-input>
                                </el-form-item>
                                <el-form-item label="金額">
                                    <MoneyInput v-model="queryParams.AMT_Min" style="width: 130px" size="small" is-search />
                                    <span style="display: inline-block; width: 40px; text-align: center">~</span>
                                    <MoneyInput v-model="queryParams.AMT_Max" style="width: 130px; margin-right: 10px" size="small" is-search />
                                    <ahElSelectCny v-model="queryParams.cny" multiple />
                                </el-form-item>
                                <el-form-item label="付款帳戶">
                                    <el-select v-model="queryParams.PAY_BNK_SNO" multiple>
                                        <el-option v-for="item in bankAccountOptions" :key="item.sno" :value="item.sno" :label="item.tpc"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="單據發票號碼">
                                    <el-input v-model="queryParams.foo" style="max-width: 400px"></el-input>
                                </el-form-item>
                                <el-form-item label="單據備註">
                                    <el-input v-model="queryParams.fileNoteKeyword" style="max-width: 400px" placeholder="輸入關鍵字"></el-input>
                                </el-form-item>
                                <el-form-item label="僅顯示待補單據">
                                    <el-checkbox v-model="queryParams.toBeAddFile"></el-checkbox>
                                </el-form-item>
                                <el-form-item label="預計付款方式">
                                    <el-select v-model="queryParams.USER_PAY_WAY" style="margin-right: 10px">
                                        <el-option :value="null" label="不限"></el-option>
                                        <el-option v-for="item in payWayList" :key="`user-pay-way-${item.value}`" :value="item.value" :label="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="實際付款方式">
                                    <el-select v-model="queryParams.PAY_WAY" style="margin-right: 10px">
                                        <el-option :value="null" label="不限"></el-option>
                                        <el-option :value="3" label="銀行提現"></el-option>
                                        <el-option v-for="item in payWayList" :key="`actual-pay-way-${item.value}`" :value="item.value" :label="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="預計付款日">
                                    <el-date-picker
                                        v-model="queryParams.ExpectePayDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="實際付款日">
                                    <el-date-picker
                                        v-model="queryParams.ActualPayDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" class="primary-action" @click="handleAdvSearchClick"> 查詢 </el-button>
                                    <el-button @click="handleAdvSearchClearClick(false)"> 清除 </el-button>
                                    <el-button @click="handleAdvSearchClearClick(true)"> 清空並返回 </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="ah-container" id="payment-page-statis">
                <el-row :gutter="20">
                    <el-col :sm="7">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    未付帳款
                                    <span v-if="!Number.isNaN(unpaidPercentage)" class="percentage"> {{ unpaidPercentage }}% </span>
                                    <ahTip>
                                        <PaymentStatusLabel :statusNum="5" /> ＋
                                        <PaymentStatusLabel :statusNum="2" />
                                        的請款金額總計</ahTip
                                    >
                                </div>
                                <div class="statis-num">
                                    <Money :v="unpaidAmt" id="payment-page-to-be-credit-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amoutTotal.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.toBeCreditedAmount + item.pendingPaymentAmount">
                                            <Money :v="item.toBeCreditedAmount + item.pendingPaymentAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny"> 約當台幣 <Money :v="item.toBeCreditedAmountTwd + item.pendingPaymentAmountTwd" round /></span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="7">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    已付帳款
                                    <span v-if="!Number.isNaN(paidPercentage)" class="percentage"> {{ paidPercentage }}% </span>
                                    <ahTip>
                                        <PaymentStatusLabel :statusNum="3" />
                                        的請款金額總計</ahTip
                                    >
                                </div>
                                <div class="statis-num">
                                    <Money :v="paidAmt" id="payment-page-credited-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amoutTotal.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.creditedAmount">
                                            <Money :v="item.creditedAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny"> 約當台幣 <Money :v="item.creditedAmountTwd" round /></span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="10">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    累計請款金額
                                    <span class="percentage">100 %</span>
                                    <ahTip>
                                        <PaymentStatusLabel :statusNum="5" /> ＋ <PaymentStatusLabel :statusNum="2" /> ＋
                                        <PaymentStatusLabel :statusNum="3" />
                                    </ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="allAmt" id="payment-page-total-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amoutTotal.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.toBeCreditedAmount + item.pendingPaymentAmount + item.creditedAmount">
                                            <Money :v="item.toBeCreditedAmount + item.pendingPaymentAmount + item.creditedAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny">
                                                約當台幣 <Money :v="item.toBeCreditedAmountTwd + item.pendingPaymentAmountTwd + item.creditedAmountTwd" round />
                                            </span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="page-statis-actions">
                    <el-button size="small" type="primary" @click="onShowCnysClick">
                        {{ isShowCnys ? "隱藏外幣" : "顯示所有幣別" }}
                    </el-button>
                </div>
            </div>
        </div>
        <div class="ah-container" style="margin-top: 25px">
            <div class="ah-panel">
                <div style="padding: 10px">
                    <div class="ah-tabs right">
                        <div
                            :class="{
                                item: true,
                                'name-only': true,
                                active: queryParams.AuditStatus == null && !queryParams.DELETED,
                            }"
                            @click="changeAuditStatus(null)"
                            @keydown="() => {}"
                        >
                            <span class="name">全部</span>
                            <span class="count">{{ classifyCounts.fullTotal }}</span>
                        </div>
                        <div
                            :class="{
                                item: true,
                                active: queryParams.AuditStatus == 1,
                            }"
                            @click="changeAuditStatus(1)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <PaymentStatusLabel :statusNum="1" :count="classifyCounts.auditingTotal" />
                            </span>
                            <span class="total">
                                <Money :v="amoutTotal.auditingAmount" round></Money>
                            </span>
                        </div>
                        <div
                            :class="{
                                item: true,
                                active: queryParams.AuditStatus == 5,
                            }"
                            @click="changeAuditStatus(5)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <PaymentStatusLabel :statusNum="5" :count="classifyCounts.pendingPayment" />
                            </span>
                            <span class="total">
                                <Money :v="amoutTotal.pendingPaymentAmount" round></Money>
                            </span>
                        </div>
                        <div
                            :class="{
                                item: true,
                                active: queryParams.AuditStatus == 2,
                            }"
                            @click="changeAuditStatus(2)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding"> <PaymentStatusLabel :statusNum="2" :count="classifyCounts.toBeCreditedTotal" /></span>
                            <span class="total">
                                <Money :v="amoutTotal.toBeCreditedAmount" round></Money>
                            </span>
                        </div>
                        <div
                            :class="{
                                item: true,
                                'name-only': true,
                                active: queryParams.AuditStatus == 3,
                            }"
                            @click="changeAuditStatus(3)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <PaymentStatusLabel :statusNum="3" :count="classifyCounts.creditedTotal" />
                            </span>
                        </div>
                        <div
                            :class="{
                                item: true,
                                active: queryParams.AuditStatus == 4,
                            }"
                            @click="changeAuditStatus(4)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding"> <PaymentStatusLabel :statusNum="4" :count="classifyCounts.rejectTotal" /></span>
                            <span class="total">
                                <Money :v="amoutTotal.rejectAmount" round></Money>
                            </span>
                        </div>
                        <div
                            :class="{
                                item: true,
                                'name-only': true,
                                active: queryParams.DELETED === true,
                            }"
                            @click="changeAuditStatus('DELETE')"
                            @keydown="() => {}"
                        >
                            <span class="name">
                                <span class="name" style="color: #848484; font-size: 9.5pt">作廢</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="panel-body" style="padding-top: 0">
                    <!-- 多選功能列 -->
                    <div class="table-bulk-actions">
                        <div class="bulk-btn-set" v-if="isShowBulkA02Btn">
                            <el-button v-if="!batchMode" size="small" @click="enableBatchMode('A02')">批次付款(已暫存) </el-button>
                            <!-- 批次確認付款 子功能 -->
                            <div class="sub-bulk-action a02" v-if="batchMode === 'A02'">
                                <el-button v-if="isEnableBulkA02Btn" type="primary" size="small" @click="handleBulkAudit('A02')">批次付款(已暫存) ({{ selectedDatas.length }}) </el-button>
                                <el-tooltip v-else content="請勾選項目" placement="top">
                                    <div style="display: inline-block; margin-right: 5px">
                                        <el-button disabled size="small">批次付款(已暫存)</el-button>
                                    </div>
                                </el-tooltip>
                                <el-button size="small" @click="disableBatchMode('A02')">取消 </el-button>
                            </div>
                        </div>
                        <div class="bulk-btn-set" v-if="isShowBulkA03Btn">
                            <el-button v-if="!batchMode" size="small" @click="enableBatchMode('A03')">批次確認付款 </el-button>
                            <!-- 批次確認付款 子功能 -->
                            <div class="sub-bulk-action a03" v-if="batchMode === 'A03'">
                                <el-button v-if="isEnableBulkA03Btn" type="primary" size="small" @click="handleBulkAudit('A03')">批次確認付款 ({{ selectedDatas.length }}) </el-button>
                                <el-tooltip v-else content="請勾選項目" placement="top">
                                    <div style="display: inline-block; margin-right: 5px">
                                        <el-button disabled size="small">批次確認付款</el-button>
                                    </div>
                                </el-tooltip>
                                <el-button size="small" @click="disableBatchMode('A03')">取消 </el-button>
                            </div>
                        </div>
                        <span>
                            <el-button v-if="isShowBulkExportPdfBtn" size="small" @click="onExportPdf">匯出 PDF（{{ selectedDatas.length }}筆） </el-button>
                            <el-tooltip v-else content="請勾選項目" placement="top">
                                <div style="display: inline-block">
                                    <el-button size="small" disabled>匯出 PDF</el-button>
                                </div>
                            </el-tooltip>
                        </span>
                    </div>
                    <PaymentTable
                        :datas="filteredDatas"
                        :showCols="tableCols"
                        :loading="isLoading"
                        :batchMode="true"
                        @detailClose="handleDetailDialogClose"
                        @sort-change="onSortChange"
                        @select-change="onTableRowSelect"
                        ref="dataTable"
                    />
                    <div v-if="batchMode !== null" style="margin-top: 25px; text-align: center">
                        <el-button v-if="batchMode !== null" @click="disableBatchMode()">取消 </el-button>
                        <el-button v-if="batchMode === 'A02' && selectedDatas.length > 0" type="primary" @click="handleBulkAudit('A02')">批次付款 ({{ selectedDatas.length }}) </el-button>
                        <el-button v-if="batchMode === 'A03' && selectedDatas.length > 0" type="primary" @click="handleBulkAudit('A03')">批次確認付款 ({{ selectedDatas.length }}) </el-button>
                    </div>
                    <el-pagination
                        :disabled="batchMode !== null"
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        @current-change="handlePaginationChange"
                        class="pagination"
                        :small="isMobile()"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <PaymentExportPdfDialog ref="exportPdfDialog" :visible="exportPdfDialog.visible" @close="exportPdfDialog_OnClose"> </PaymentExportPdfDialog>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { paymentType, datePickerOption } from '@/assets/commonData/options';
import Money from '@/components/ui/Money.vue';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import ahTip from '@/components/ui/ahTip.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import PaymentStatusLabel from './PaymentStatusLabel.vue';
import PaymentTable from './PaymentTable.vue';
import PaymentExportMixins from './PaymentExportMixins';
import PaymentExportPdfDialog from './PaymentExportPdfDialog2.vue';

export default {
    name: 'PaymentPage',
    mixins: [PaymentExportMixins],
    components: {
        PaymentTable,
        PaymentStatusLabel,
        Money,
        ahElSelectCny,
        ahTip,
        ahSelectVariableStateItem,
        PaymentExportPdfDialog,
    },
    data() {
        return {
            paymentType,
            isLoading: false,
            isShowFilter: false,
            showCheckbox: true,
            batchMode: null,
            statusBeforeBatchMode: null,
            datePeriodType: null,
            selectedSno: null,
            selectedDatas: [],
            queryParams: {
                PageNum: 1,
                PageSize: 25,
                PayooOrNote: null,
                PaymentType: [], // 1:一般請款 2:專案請款 3:特定費用請款 4:經常性費用請款
                ProjectId: null,
                SpecialProjectId: null,
                PayeeName: null,
                ExpectePayStartDate: null,
                ExpectePayEndDate: null,
                ActualPayStartDate: null,
                ActualPayEndDate: null,
                PaymentStartDate: null,
                PaymentEndDate: null,
                Creator: [],
                VDR_BNK_BOO: null,
                PAY_BNK_SNO: null,
                AMT_Min: null,
                AMT_Max: null,
                cny: null,
                USER_PAY_WAY: null, // 1=零用現金(扣ac_cash) 2=匯款銀行戶頭
                PAY_WAY: null,
                ITEM_SNO: [],
                AuditStatus: null,
                DELETED: false,
                PaymentDate: null,
                ExpectePayDate: null,
                ActualPayDate: null,
                foo: null,
                fileNoteKeyword: null,
                a02_ISTEMP: null,
                toBeAddFile: false,
            },
            prevQuery: {},

            OrderParam: {
                SortColumn: null,
                OrderBy: null,
            },

            amoutTotal: {},
            classifyCounts: {},
            datas: [],
            clientList: [],
            projectList: [],
            spProjectList: [],
            payWayList: [
                { value: 2, label: '銀行轉帳' },
                { value: 1, label: '零用現金' },
            ],
            creatorOptions: [],
            totalDataCount: 0,
            dateFilterValue: null,
            dateTarget: null,

            isLoadingExport: false,

            yearList: [],
            pickerOptions: datePickerOption,
            isShowCnys: false,
            exportPdfDialog: {
                visible: false,
            },
        };
    },
    computed: {
        isAhooAgent() {
            return this.$store.getters['account/isAhooAgent'];
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
        unpaidAmt() {
            return this.amoutTotal.toBeCreditedAmount + this.amoutTotal.pendingPaymentAmount;
        },
        paidAmt() {
            return this.amoutTotal.creditedAmount;
        },
        allAmt() {
            return this.amoutTotal.toBeCreditedAmount + this.amoutTotal.pendingPaymentAmount + this.amoutTotal.creditedAmount;
        },
        unpaidPercentage() {
            return Math.round((this.unpaidAmt / this.allAmt) * 1000) / 10;
        },
        paidPercentage() {
            return Math.round((100 - this.unpaidPercentage) * 10) / 10;
        },
        tableCols() {
            if (this.batchMode === 'A02') {
                return ['payoo', 'status', 'nam', 'creator', 'paY_DAT', 'paY_WAY', 'paY_BNK', 'amt'];
            }
            if (this.batchMode === 'A03') {
                return ['payoo', 'status', 'nam', 'creator', 'paY_DAT', 'paY_WAY', 'paY_BNK', 'amt'];
            }
            if (this.queryParams.AuditStatus === 2 || this.queryParams.AuditStatus === 3) {
                return ['payoo', 'status', 'nam', 'paY_DAT', 'creator', 'progress', 'amt'];
            }

            return ['payoo', 'status', 'nam', 'pdat', 'creator', 'progress', 'amt'];
        },
        batchCheckedCount() {
            return 0;
        },
        // 轉換資料 keys 給 filter 元件使用
        paymentTypeFDatas() {
            return _.chain(this.paymentType)
                .filter((o) => o.key)
                .map((o) => ({
                    value: o.key,
                    name: o.value,
                }))
                .value();
        },
        projectFDatas() {
            const datas = [];
            datas.push({ value: null, name: '所有專案' });
            for (let i = 0; i < this.projectList.length; i += 1) {
                datas.push({
                    value: this.projectList[i].sno,
                    name: this.projectList[i].nam,
                });
            }
            return datas;
        },
        typeFDatas() {
            const datas = [];
            datas.push({ value: null, name: '所有專案' });
            for (let i = 0; i < this.projectList.length; i += 1) {
                datas.push({
                    value: this.projectList[i].sno,
                    name: this.projectList[i].nam,
                });
            }
            return datas;
        },
        filteredDatas() {
            // if (this.batchMode === 'A02') {
            //     return this.datas.filter(
            //         (item) => item.sigN_STS === 5 && !item.deleted && item.a02_ISTEMP === true,
            //     );
            // }
            // if (this.batchMode === 'A03') {
            //     return this.datas.filter((item) => item.sigN_STS === 2 && !item.deleted);
            // }
            return this.datas;
        },
        bankAccountOptions() {
            return this.$store.getters['bankAccount/bankAccountOptions'];
        },
        yearSelect: {
            set(val) {
                if (!val) {
                    this.queryParams.PaymentDate = null;
                    this.updateData(true);
                    return;
                }

                const sd = Number(moment().year(val).startOf('year').format('x'));
                const ed = Number(moment().year(val).endOf('year').format('x'));

                this.queryParams.PaymentDate = [sd, ed];
                this.updateData(true);
            },
            get() {
                if (!this.queryParams.PaymentDate) return '所有年份';
                const year = moment(Number(this.queryParams.PaymentDate[0])).year();
                const daysOfYear = year % 4 === 0 ? 366 : 365;
                const sd = moment(Number(this.queryParams.PaymentDate[0]));
                const ed = moment(Number(this.queryParams.PaymentDate[1]));

                // eslint-disable-next-line eqeqeq
                if (sd.format('DDD') == 1 && ed.format('DDD') == daysOfYear) {
                    return year;
                }
                return '自訂';
            },
        },
        isShowBulkA02Btn() {
            if (this.queryParams.DELETED === true) return false;
            if (!this.isAuth('A02')) return false;
            // 狀態分頁為：全部、待付款，才顯示
            if (this.queryParams.AuditStatus !== null && this.queryParams.AuditStatus !== 5) return false;
            return true;
        },
        isShowBulkA03Btn() {
            if (this.queryParams.DELETED === true) return false;
            if (!this.isAuth('A03')) return false;
            // 狀態分頁為：全部、待確認付款，才顯示
            if (this.queryParams.AuditStatus !== null && this.queryParams.AuditStatus !== 2) return false;
            return true;
        },
        isEnableBulkA02Btn() {
            if (this.selectedDatas.length <= 0) return false;
            // 已勾選的項目全部都要是"待付款(已暫存)"(sigN_STS == 5 && a02_ISTEMP)
            for (let i = 0; i < this.selectedDatas.length; i++) {
                const item = this.selectedDatas[i];
                if (item.deleted) return false;
                if (item.sigN_STS !== 5) return false;
                if (item.a02_ISTEMP !== true) return false;
            }
            return true;
        },
        isEnableBulkA03Btn() {
            // 已勾選的項目全部都要是"待確認付款"(sigN_STS == 2)
            if (this.selectedDatas.length <= 0) return false;
            for (let i = 0; i < this.selectedDatas.length; i++) {
                const item = this.selectedDatas[i];
                if (item.deleted) return false;
                if (item.sigN_STS !== 2) return false;
            }
            return true;
        },
        isShowBulkExportPdfBtn() {
            if (this.selectedDatas.length <= 0) return false;
            return true;
        },
    },
    mounted() {
        this.initYearSelect();
        this.updateData();
        this.fetchCreatorOptions();
        this.$store.dispatch('accounting/updateAccountingSettings');
    },
    methods: {
        initYearSelect() {
            const START = 2020;
            const END = moment().year() + 1;

            this.yearList = [];
            this.yearList.push({ label: '所有年份', value: null });
            for (let i = END; i >= START; i -= 1) {
                this.yearList.push({ label: i, value: i, key: `year-list-${i}-${+new Date()}` });
            }

            const sd = Number(moment().startOf('year').format('x'));
            const ed = Number(moment().endOf('year').format('x'));
            this.queryParams.PaymentDate = [sd, ed];
        },
        onSimpleSearchKeyUp() {
            if (!this.isShowFilter) this.queryParams.PaymentDate = null;
            this.updateData(true);
        },
        handleAdvSearchClick() {
            this.updateData(true);
            setTimeout(() => {
                this.scrollToId('payment-page-statis', 'start');
            }, 300);
        },

        handleAdvSearchClearClick(resumeDefault) {
            this.queryParams = {
                PageNum: 1,
                PageSize: 25,
                PayooOrNote: null,
                PaymentType: [], // 1:一般請款 2:專案請款 3:特定費用請款 4:經常性費用請款
                ProjectId: null,
                SpecialProjectId: null,
                PayeeName: null,
                ExpectePayStartDate: null,
                ExpectePayEndDate: null,
                ActualPayStartDate: null,
                ActualPayEndDate: null,
                Creator: [],
                VDR_BNK_BOO: null,
                PAY_BNK_SNO: null,
                AMT_Min: null,
                AMT_Max: null,
                cny: null,
                USER_PAY_WAY: null, // 1=零用現金(扣ac_cash) 2=匯款銀行戶頭
                ITEM_SNO: [],
                AuditStatus: null,
                PaymentDate: null,
                ExpectePayDate: null,
                ActualPayDate: null,
                fileNoteKeyword: null,
            };
            this.$refs.ahSelectVariableStateItem.clear();

            if (resumeDefault) {
                this.initYearSelect();
                this.isShowFilter = false;
                this.updateData(true);
            }

            this.scrollToId('payment-page-header', 'start');
        },
        handleAdvSearchProjectTypeChange() {
            // 專案請款
            if (this.queryParams.PaymentType.includes(2)) {
                this.fetchProjectList();
            } else this.queryParams.ProjectId = null;

            // 特定費用項目請款
            if (this.queryParams.PaymentType.includes(3)) {
                this.fetchSpProjectList();
            } else this.queryParams.SpecialProjectId = null;
        },

        handleAddBtnClick() {
            this.$router.push({ name: 'payment-add' });
        },
        onSortChange(event) {
            if (event.order === 'ascending') {
                this.OrderParam.OrderBy = 1;
            }
            if (event.order === 'descending') {
                this.OrderParam.OrderBy = 2;
            }
            if (event.order === null) {
                this.OrderParam.OrderBy = null;
            }
            this.OrderParam.SortColumn = event.prop;
            this.updateData();
        },

        enableBatchMode(type) {
            // 紀錄進入批次模式前的狀態分頁
            this.statusBeforeBatchMode = this.queryParams.AuditStatus;

            // 批次付款(已暫存)：需載入單獨顯示待付款(已暫存)的列表
            if (type === 'A02') {
                if (this.queryParams.AuditStatus !== 5 || !this.queryParams.a02_ISTEMP) {
                    // 應改為fatch只有"待付款(已暫存)"的列表
                    // 但此列表的狀態仍呈現5(待付款)
                    this.changeAuditStatus(5, true, true);
                }
            }
            // 批次確認付款：切換分頁
            if (type === 'A03') {
                if (this.queryParams.AuditStatus !== 2) {
                    this.changeAuditStatus(2, null, true);
                }
            }
            this.batchMode = type;
        },

        disableBatchMode(type) {
            this.batchMode = null;

            // 沒有選取項目就取消，就回到原本狀態分頁（很可能錯點或只是看看）
            if (this.selectedDatas.length <= 0) {
                if (this.statusBeforeBatchMode !== this.queryParams.AuditStatus) {
                    this.changeAuditStatus(this.statusBeforeBatchMode);
                }
            }
        },

        handlePaginationChange() {
            this.updateData();
        },

        handleDetailDialogClose(refresh) {
            if (refresh) this.updateData();

            if (this.$route.name !== 'payment') {
                this.$router.push({ name: 'payment' });
            }
        },
        applyDateToQueryParams() {
            // 第二個日期都加一天（後端搜尋規則 >= start && < end ）
            if (this.queryParams.PaymentDate) {
                const [startDate, endDate] = this.queryParams.PaymentDate;
                this.queryParams.PaymentStartDate = startDate;
                this.queryParams.PaymentEndDate = +moment(+endDate).endOf('day').format('x');
            } else {
                this.queryParams.PaymentStartDate = null;
                this.queryParams.PaymentEndDate = null;
            }

            if (this.queryParams.ExpectePayDate) {
                const [startDate, endDate] = this.queryParams.ExpectePayDate;
                this.queryParams.ExpectePayStartDate = startDate;
                this.queryParams.ExpectePayEndDate = +moment(+endDate).endOf('day').format('x');
            } else {
                this.queryParams.ExpectePayStartDate = null;
                this.queryParams.ExpectePayEndDate = null;
            }

            if (this.queryParams.ActualPayDate) {
                const [startDate, endDate] = this.queryParams.ActualPayDate;
                this.queryParams.ActualPayStartDate = startDate;
                this.queryParams.ActualPayEndDate = +moment(+endDate).endOf('day').format('x');
            } else {
                this.queryParams.ActualPayStartDate = null;
                this.queryParams.ActualPayEndDate = null;
            }
        },

        updateData(resetPageNum = false, callback) {
            this.isLoading = true;

            if (resetPageNum) this.queryParams.PageNum = 1;

            this.applyDateToQueryParams();
            this.prevQuery = { ...this.queryParams };

            let params = { ...this.queryParams };
            if (this.OrderParam.SortColumn !== null && this.OrderParam.OrderBy !== null) {
                params = { ...this.OrderParam, ...this.queryParams };
            }

            const { query, resetQuery } = this.getManualQuery(this.prevQuery);

            this.$api({
                url: `PaymentManagenmentPage/QueryPayment${query}`,
                params: { ...params, ...resetQuery },
                method: 'GET',
            })
                .then((resp) => {
                    if (this.queryParams.PageNum !== 1 && !resp.data.totalNum) {
                        this.queryParams.PageNum -= 1;
                        this.updateData();
                        return;
                    }
                    this.datas = resp.data.items;
                    this.amoutTotal = resp.data.amoutTotal;
                    this.classifyCounts = resp.data.item;
                    this.totalDataCount = resp.data.totalNum;
                })
                .finally(() => {
                    this.isLoading = false;
                    if (callback) callback();
                });
        },
        changeAuditStatus(status, tempOnly = null, preSelect = false) {
            const selectedSnos = this.selectedDatas.map((s) => s.sno);

            this.queryParams.a02_ISTEMP = tempOnly;
            this.OrderParam.SortColumn = undefined;

            if (status === 'DELETE') {
                this.queryParams.AuditStatus = null;
                this.queryParams.DELETED = true;
            } else {
                this.queryParams.AuditStatus = status;
                this.queryParams.DELETED = false;
            }

            if (this.batchMode) {
                this.disableBatchMode();
            }

            this.updateData(true, () => {
                if (preSelect) {
                    if (selectedSnos && selectedSnos.length > 0) {
                        selectedSnos.forEach((sno) => {
                            this.$refs.dataTable.selectRowBySno(sno, true);
                        });
                    }
                }
            });
        },
        async fetchProjectList(query) {
            try {
                const resp = await this.$api({
                    url: 'PaymentManagenmentPage/GetProjectOptions?Type=1',
                    method: 'GET',
                    params: { keyword: query },
                });
                this.projectList = resp.data.options;
            } catch (e) {
                console.log(e);
            }
        },
        projectRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchProjectList(query);
        },
        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },

        fetchSpProjectList() {
            this.$api({
                url: 'PaymentManagenmentPage/GetProjectOptions?Type=2',
                method: 'GET',
            }).then((resp) => {
                this.spProjectList = resp.data.options;
            });
        },
        async fetchCreatorOptions() {
            const resp = await this.$api({
                url: 'PaymentManagenmentPage/GetAgentIds',
                method: 'GET',
            });
            this.creatorOptions = _.chain(resp.data.items)
                .filter((x) => x.sno !== 1)
                .filter((o) => (this.isAhooAgent ? true : o.nam !== 'Ahoo專員'))
                .value();
        },

        handleBulkAudit(type) {
            const apiForA02 = '/PaymentManagenmentPage/BulkAuditToA03';
            const apiForA03 = '/PaymentManagenmentPage/BulkAuditPayment';

            // 批次付款（已暫存）檢查付款日期是否超過今天
            if (type === 'A02') {
                const now = new Date().getTime();
                const invalidPayment = this.selectedDatas.find((x) => x.paY_DAT > now);
                if (invalidPayment) {
                    this.$message({
                        showClose: true,
                        message: `含有實際付款日期超過今日的請款單：${invalidPayment.nam}`,
                        type: 'error',
                    });
                    return;
                }
            }

            let apiUrl = apiForA02;
            if (type === 'A03') apiUrl = apiForA03;

            let alertMsg = `確定要登記 ${this.selectedDatas.length} 張請款單為已付款嗎？`;
            if (type === 'A03') {
                alertMsg = `確定要確認 ${this.selectedDatas.length} 張請款單嗎？`;
            }

            if (this.selectedDatas.length > 0) {
                if (confirm(alertMsg)) {
                    const snoList = this.selectedDatas.map((item) => item.sno);

                    this.$api({
                        url: apiUrl,
                        method: 'POST',
                        data: { snos: snoList },
                    }).then((resp) => {
                        console.log('br', resp);
                        // 有錯誤訊息
                        if (resp.data.failItems && resp.data.failItems.length > 0) {
                            for (let i = resp.data.failItems.length - 1; i >= 0; i -= 1) {
                                this.$message({
                                    showClose: true,
                                    message: resp.data.failItems[i],
                                    type: 'error',
                                });
                            }
                        }

                        this.updateData(true);
                    });
                }
            } else {
                this.$message({
                    showClose: true,
                    message: '沒有勾選的請款。',
                    type: 'warning',
                });
            }
        },
        onPageClick(event) {
            if (event.target.classList.contains('ah-page') || event.target.classList.contains('ah-container')) {
                this.$refs.dataTable.removeHighlight();
            }
        },
        getManualQuery(query) {
            const returnValue = [
                ..._.map(query.PaymentType, (o) => `PaymentType=${o}`),
                ..._.map(query.Creator, (o) => `Creator=${o}`),
                ..._.map(query.PAY_BNK_SNO, (o) => `PAY_BNK_SNO=${o}`),
                ..._.map(query.cny, (o) => `cny=${o}`),
                ..._.map(query.ITEM_SNO, (o) => `ITEM_SNO=${o}`),
            ];
            return {
                query: returnValue.length ? `?${returnValue.join('&')}` : '',
                resetQuery: {
                    PaymentType: undefined,
                    Creator: undefined,
                    PAY_BNK_SNO: undefined,
                    ITEM_SNO: undefined,
                    cny: undefined,
                    PaymentDate: undefined,
                    ExpectePayDate: undefined,
                    ActualPayDate: undefined,
                },
            };
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        onShowCnysClick() {
            this.isShowCnys = !this.isShowCnys;
        },
        exportPdfDialog_OnClose() {
            this.exportPdfDialog.visible = false;
        },
        onExportPdf() {
            const snoList = [];
            this.selectedDatas.forEach((data) => {
                snoList.push(data.sno);
            });
            this.$refs.exportPdfDialog.setSnoList(snoList);
            this.exportPdfDialog.visible = true;
        },
        onTableRowSelect(selection) {
            this.selectedDatas = selection;
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.payment-page {
    .payment-progress {
        margin-right: 30px;

        .el-step__title {
            font-size: 9pt;
        }

        .el-step__icon {
            width: 14px;
            height: 14px;

            .el-step__icon-inner {
                display: none;
            }
        }

        .el-step.is-horizontal .el-step__line {
            top: 8px;
        }
    }

    .search {
        width: 250px;

        @media (max-width: 720px) {
            width: 150px;
        }
    }
    .cny-hint {
        position: relative;
        top: -10px;
        font-size: 10pt;
        color: #fff;
        opacity: 0.7;
    }

    .bulk-btn-set {
        display: inline-block;
        margin: 0 5px;
    }
    .sub-bulk-action {
        display: inline-block;
        margin: 0 10px 0 0;
    }
}
</style>
